<template>
  <div class="game-details-content">
    <!-- Most Popular Answers: index 0 -->
    <div class="accordian-panel">
      <div class="accordian-header" @click="toggle(0)">
        Most Popular Answers
        <span class="chevron" :class="{ 'chevron-up': !isActive(0) }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave">
        <div v-if="isActive(0)" class="accordian-content">
          <popularAnswerBoard
            class="popular-answer-board"
            :score="score"
            :boardId="boardId"
            :board="board"
            :liveRarityData="liveRarityData"
            :gameData="gameData"
            :countryData="countryData"
            :answersList="answersList"
          ></popularAnswerBoard>
        </div>
      </transition>
    </div>

    <!-- Least Popular Answers: index 1 -->
    <div class="accordian-panel">
      <div class="accordian-header" @click="toggle(1)">
        Least Popular Answers
        <span class="chevron" :class="{ 'chevron-up': !isActive(1) }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave">
        <div v-if="isActive(1)" class="accordian-content">
          <leastCommonAnswers
            class="popular-answer-board"
            :score="score"
            :boardId="boardId"
            :board="board"
            :liveRarityData="liveRarityData"
            :gameData="gameData"
            :countryData="countryData"
            :answersList="answersList"
          ></leastCommonAnswers>
        </div>
      </transition>
    </div>

    <!-- Answer Frequency: index 2 -->
    <div class="accordian-panel">
      <div class="accordian-header" @click="toggle(2)">
        Answer Frequency
        <span class="chevron" :class="{ 'chevron-up': !isActive(2) }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave">
        <div v-if="isActive(2)" class="accordian-content">
          <answerFreq
            class="popular-answer-board"
            :score="score"
            :board="board"
            :boardId="+boardId"
            :localLiveRarityData="localLiveRarityData"
            :gameData="gameData"
            :plays="totalPlays"
          ></answerFreq>
        </div>
      </transition>
    </div>

    <!-- Board Answers: index 3 -->
    <div class="accordian-panel">
      <div class="accordian-header" @click="toggle(3)">
        Board Answers
        <span class="chevron" :class="{ 'chevron-up': !isActive(3) }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave">
        <div v-if="isActive(3)" class="accordian-content">
          <showAnswersBoard
            class="popular-answer-board"
            :board="board"
            :gameData="gameData"
            :answersList="answersList"
          ></showAnswersBoard>
        </div>
      </transition>
    </div>

    <!-- Wrong Answers: index 4 -->
    <div v-if="wrongGuesses.length" class="accordian-panel">
      <div class="accordian-header" @click="toggle(4)">
        <div class="new-header">
          Your Wrong Answers
          <div v-if="Date.now() < 1740787200000" class="new-label">New!</div>
        </div>
        <span class="chevron" :class="{ 'chevron-up': !isActive(4) }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave">
        <div v-if="isActive(4)" class="accordian-content">
          <wrongAnswersBoard
            class="popular-answer-board"
            :board="board"
            :gameData="gameData"
            :wrongGuesses="wrongGuesses"
          ></wrongAnswersBoard>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import popularAnswerBoard from '../boards/popularAnswerBoard.vue';
  import answerFreq from '../boards/answerFreq.vue';
  import showAnswersBoard from '../boards/showAnswersBoard.vue';
  import leastCommonAnswers from '../boards/leastCommonAnswers.vue';
  import wrongAnswersBoard from '../boards/wrongAnswersBoard.vue';

  export default {
    name: 'GameDetailsTab',
    components: {
      popularAnswerBoard,
      answerFreq,
      showAnswersBoard,
      leastCommonAnswers,
      wrongAnswersBoard,
    },
    props: [
      'score',
      'boardId',
      'board',
      'plays',
      'totalPlays',
      'liveRarityData',
      'gameData',
      'countryData',
      'answersList',
      'wrongGuesses',
    ],
    data() {
      return {
        localLiveRarityData: JSON.parse(localStorage.getItem(`answer_freq_data_${this.boardId}`)),
        activeIndex: 0,
      };
    },
    methods: {
      toggle(index) {
        if (this.activeIndex == index) {
          this.activeIndex = -1;
          return;
        }
        this.activeIndex = index;
      },
      isActive(index) {
        return this.activeIndex == index;
      },
      onEnter(el) {
        el.style.height = '0px';
        el.style.opacity = '0';
        el.style.overflow = 'hidden';
        // força reflow:
        void el.offsetHeight;
        el.style.transition = 'height 300ms ease, opacity 300ms ease';
        el.style.height = el.scrollHeight + 'px';
        el.style.opacity = '1';
      },
      onAfterEnter(el) {
        el.style.height = 'auto'; // libera para crescer conforme conteúdo
        el.style.overflow = ''; // opcional: remove o overflow inline
      },
      onLeave(el) {
        el.style.height = el.scrollHeight + 'px';
        el.style.opacity = '1';
        el.style.overflow = 'hidden';
        // força reflow:
        void el.offsetHeight;
        el.style.transition = 'height 300ms ease, opacity 300ms ease';
        el.style.height = '0px';
        el.style.opacity = '0';
      },
    },
  };
</script>

<style scoped>
  .game-details-content {
    margin: auto;
    color: white;
    max-width: 600px;
  }

  .accordian-panel {
    padding: 0;
    padding-top: 10px;
    border: none;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: center;
  }

  .accordian-header {
    display: flex;
    width: 100%;
    max-width: 600px;
    align-items: center;
    justify-content: space-between;
    font-size: 1.25rem;
    font-weight: 600;
    color: white;
    padding: 10px;
    border: none;
    cursor: pointer;
    margin: 0;
    box-sizing: border-box;
    text-align: center;
    border-radius: 8px;
  }

  .accordian-header:hover {
    background: rgba(42, 42, 58, 0.8);
  }

  .chevron {
    display: inline-block;
    text-align: center;
    font-size: 1.6rem;
    transition: transform 0.3s ease;
    transform: rotate(180deg);
  }

  .chevron-up {
    transform: rotate(0deg);
  }

  .accordian-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    will-change: height, opacity; /* performance hint */
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.6s ease;
    transform-origin: top;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: scaleY(0);
    max-height: 0;
    opacity: 0;
  }

  .slide-fade-enter-to,
  .slide-fade-leave-from {
    transform: scaleY(1);
    max-height: 700px;
    opacity: 1;
  }

  @media (min-width: 769px) {
    .accordian-panel {
      min-width: 600px;
    }
  }

  @media (max-width: 768px) {
    .popular-answer-board {
      height: 20%;
    }
    .game-details-content {
      width: 100%;
    }
    .accordian-header {
      font-size: 1rem;
      padding: 8px;
    }
  }

  @media (max-width: 480px) {
    .game-details-content {
      width: 100%;
    }
    .popular-answer-board {
      height: 20%;
      width: 100%;
    }
    .accordian-header {
      font-size: 0.9rem;
      padding: 8px;
    }
  }
  @media (max-width: 360px) {
    .game-details-content {
      width: 96%;
    }
  }
</style>
